'use client';

import { useEffect } from 'react';

import { useSearchParams } from 'next/navigation';

/**
 * Composant qui applique une couleur de fond personnalisée en fonction des paramètres d'URL
 * Utilisé principalement pour le mode "intégré" (iframe)
 */
export default function BackgroundColorByParam() {
    const searchParams = useSearchParams();

    // Couleur de fond par défaut pour le mode intégré
    const defaultIntegratedBg = '#ffffff';

    // Récupère le type d'écran depuis les paramètres d'URL
    const screenType = searchParams?.get('screenType');

    // Vérifie si le mode intégré est activé
    const shouldApply = screenType === 'integrated';

    useEffect(() => {
        // Si le mode intégré n'est pas activé, ne rien faire
        if (!shouldApply) return;

        // Définit une variable CSS sur :root pour permettre la surcharge ou l'utilisation dans d'autres styles
        try {
            document.documentElement.style.setProperty('--mantine-integrated-bg', defaultIntegratedBg);
            // Applique également directement sur le body pour un effet visuel immédiat
            document.body.style.background = `var(--mantine-integrated-bg)`;
        } catch {
            // Gestion silencieuse des erreurs (ex: document non disponible en SSR)
        }

        // Fonction de nettoyage pour restaurer l'état initial
        return () => {
            try {
                document.documentElement.style.removeProperty('--mantine-integrated-bg');
                document.body.style.background = '';
            } catch {
                // Gestion silencieuse des erreurs
            }
        };
    }, [defaultIntegratedBg, shouldApply]);

    return null;
}
